vi.mock('../hooks/useOutsideEvent', () => ({
  useOutsideEvent: vi.fn(),
}));

export {};
